import React from "react";
import Container from "@mui/material/Container";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import _ from "lodash";
import { authContext } from "../../../contexts/AuthContext";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { withTranslation } from "react-i18next";
import SocietyCard from "./SocietyCard";
import PageTitle from "../../PageTitle";
import { insertSociety, listSocietysByUser } from "../../../services/societies";
import SocietyForm from "./SocietyForm";

class Societies extends React.Component {
  constructor() {
    super();

    this.state = {
      societys: [],
      filteredSocietys: [],
      addSociety: {},
      addSocietyError: {},
      snackbarInfoOpen: false,
    };
  }

  static contextType = authContext;

  componentDidMount() {
    this.fetchSocietyList();
  }

  fetchSocietyList = async () => {
    let societyList = await listSocietysByUser(this.context.auth.user.id);
    this.setState({
      societys: societyList,
      filteredSocietys: societyList,
    });
  };

  handleAddSocietyOpen = () => {
    this.setState({
      addSociety: { id: -1, type: "" },
    });
  };

  handleAddSocietyClose = () => {
    this.setState({
      addSociety: {},
      addSocietyError: {},
    });
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarInfoOpen: false,
    });
  };

  insertSociety = async () => {
    const { addSociety } = this.state;

    const params = {
      type: addSociety.type,
      legal_id: addSociety.legal_id,
      address: addSociety.address,
      country: addSociety.country,
      language: addSociety.language,
      current_status: addSociety.current_status,
      constitution_date: addSociety.constitution_date,
      contact_email: addSociety.contact_email,
      phone_country_code: addSociety.phone_country_code,
      phone_number: addSociety.phone_number,
      loggedUserId: this.context.auth.user.id,
    };

    try {
      let society = await insertSociety(params);

      this.setState((prevState) => ({
        societys: [...prevState.societys, society],
        filteredSocietys: [...prevState.filteredSocietys, society],
        addSociety: {},
        snackbarInfoOpen: true,
      }));
    } catch (err) {
      console.error("Error inserting society:", err);
      this.setState({ snackbarInfoOpen: true });
    }
  };

  validAddSociety = () => {
    const { addSociety } = this.state;

    let error = {
      type: _.isEmpty(addSociety.type),
      legal_id: _.isEmpty(addSociety.legal_id),
    };

    this.setState({ addSocietyError: error });

    return !error.type && !error.legal_id;
  };

  filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const res = this.state.societys.filter((society) => {
        return (
          (society.type &&
            society.type.toLowerCase().includes(keyword.toLowerCase())) ||
          (society.legal_id &&
            society.legal_id.toLowerCase().includes(keyword.toLowerCase()))
        );
      });
      this.setState({
        filteredSocietys: res,
      });
    } else {
      this.setState({
        filteredSocietys: this.state.societys,
      });
    }
  };

  cardDeleteHandler = (society) => {
    _.remove(this.state.societys, (s) => s.id === society.id);
    _.remove(this.state.filteredSocietys, (s) => s.id === society.id);
    this.forceUpdate();
  };

  render() {
    const { t } = this.props;

    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container>
          <Grid item xs={6}>
            <PageTitle>{t("Societies")}</PageTitle>
          </Grid>
          <Grid item xs={6} container justifyContent="flex-end">
            <Button
              sx={{
                m: 3,
                backgroundColor:
                  window.$brand === "PRB" ? "#17afb6" : "#102a46",
                borderRadius: window.$brand === "PRB" ? 0 : 5,
              }}
              variant="contained"
              startIcon={<AddIcon />}
              onClick={this.handleAddSocietyOpen}
            >
              {t("Add_society")}
            </Button>
          </Grid>
        </Grid>

        <TextField
          id="society-search"
          label={t("Society_filter")}
          onChange={this.filter}
          type="text"
          fullWidth
          variant="standard"
          sx={{ mb: 4, mt: 1 }}
        />

        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {this.state.filteredSocietys.map((society) => (
            <Grid item xs={12} sm={8} md={4} key={society.id}>
              <SocietyCard
                society={society}
                cardDeleteHandler={this.cardDeleteHandler}
              />
            </Grid>
          ))}
        </Grid>

        <Dialog
          open={!_.isEmpty(this.state.addSociety)}
          onClose={this.handleAddSocietyClose}
        >
          <DialogTitle>{t("Add_society")}</DialogTitle>
          <DialogContent
            sx={{
              display: "flex",
              gap: 2,
              flexDirection: "column",
              minWidth: 400,
            }}
          >
            <SocietyForm
              value={this.state.addSociety}
              onChange={(v) => this.setState({ addSociety: v })}
              t={t}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleAddSocietyClose}>{t("Cancel")}</Button>
            <Button
              onClick={() => {
                if (this.validAddSociety()) this.insertSociety();
              }}
            >
              {t("Save")}
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.snackbarInfoOpen}
          autoHideDuration={4000}
          onClose={this.handleSnackbarClose}
          key={"bottomcentererror"}
        >
          <Alert elevation={6} variant="filled" severity="info">
            {t("saved_successfully")}
          </Alert>
        </Snackbar>
      </Container>
    );
  }
}

export default withTranslation()(Societies);
